// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GOeKL1kIyewwng {
  position: relative;
  min-width: 500px;
  max-width: 880px;
  margin: auto;
  border-radius: 12px;
  background-color: var(--ds-surface, #ffffff);
}
.duOgsgeixhFUOg {
  display: block;
  width: 100%;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.jroTQLAx5FGbhX {
  padding: 32px 48px 40px 48px;
  text-align: center;
}
.yml0dNPkzQDIpH {
  display: flex;
  justify-content: center;
  margin-top: 40px;
  column-gap: 8px;
}
.n6OK015MEi910y {
  position: absolute;
  top: 8px;
  right: 16px;
  color: #ffffff;
}
.n6OK015MEi910y:hover,
.n6OK015MEi910y:active {
  color: #ffffff;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"gaWelcomeModal": `GOeKL1kIyewwng`,
	"headingImage": `duOgsgeixhFUOg`,
	"contentContainer": `jroTQLAx5FGbhX`,
	"ctasContainer": `yml0dNPkzQDIpH`,
	"closeButton": `n6OK015MEi910y`
};
export default ___CSS_LOADER_EXPORT___;
